import {
  getChildPortionId,
  getSelectedChoices,
  getSelectedPortion,
} from 'menu/utils';
import { Button } from 'react-bootstrap';
import { AztecProduct, Choice, ChoiceGroup } from 'types/models';
import { emptyStringFallback } from 'utils';

interface SelectedNestedChoiceInfoProps {
  productToUse?: AztecProduct;
  choiceToUse?: ChoiceGroup;
  choiceGroup: ChoiceGroup;
  choice: Choice;
  portionId: number;
  handleEditNestedChoice: () => void;
}

export const SelectedNestedChoiceInfo: React.FC<
  SelectedNestedChoiceInfoProps
> = ({
  productToUse,
  choiceToUse,
  choiceGroup,
  choice,
  portionId,
  handleEditNestedChoice,
}) => {
  const portionIdToUse: number = getChildPortionId(
    choiceGroup.portionRatios,
    choice.choiceId ?? choice.productId,
    portionId,
  );

  const hasChoices = productToUse
    ? productToUse.portions[portionIdToUse]?.choices?.length > 0
    : true;

  const hasSelectedNestedChoice = hasChoices && (choice.quantity ?? 0) > 0;

  const choicesArray: Choice[] = [];

  if (productToUse) {
    const nestedPortion = getSelectedPortion(productToUse);
    if (nestedPortion) {
      nestedPortion.choices.forEach((c) => {
        choicesArray.push(...getSelectedChoices(c?.choiceGroup?.choices));
      });
    }
  }

  if (choiceToUse) {
    choicesArray.push(...getSelectedChoices(choiceToUse.choices));
  }

  return hasSelectedNestedChoice && choicesArray.length > 0 ? (
    <div className="nested-choice-info">
      <ul>
        {choicesArray.map((selectedChoice) => (
          <li key={selectedChoice.choiceId ?? selectedChoice.productId}>
            {emptyStringFallback(
              selectedChoice?.displayRecordToUse?.name,
              selectedChoice?.productToUse?.eposName,
            )}
          </li>
        ))}
      </ul>
      <Button bsStyle="default" bsSize="small" onClick={handleEditNestedChoice}>
        Edit Selections
      </Button>
    </div>
  ) : null;
};
